import { render, staticRenderFns } from "./Vessel.vue?vue&type=template&id=028ddf71&scoped=true"
import script from "./Vessel.vue?vue&type=script&lang=js"
export * from "./Vessel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028ddf71",
  null
  
)

export default component.exports